export enum ELimitsPeriod {
  Day = 'day',
  Days = 'days',
  Month = 'month',
  Week = 'week',
  Year = 'year',
}
